import { useFilterPackageTransportContext } from "./filter-package-transport.context";

export function FilterPackageTransport() {
  const { dateFilterElement, clearFiltersElement } =
    useFilterPackageTransportContext();

  return (
    <div>
      <h2>Filters</h2>
      <p className="mb-4">
        Select the following filters you want to apply to the current table.
      </p>

      {dateFilterElement}
      {clearFiltersElement}
    </div>
  );
}